import React, { memo, useMemo } from "react";
import { HStack, Text, VStack, Highlight } from "@chakra-ui/react";
import colors from "app/colors";
import { HappycoWorkOrderFragment } from "gql/graphql";
import moment from "moment";
import { COMMON_DATE_CALENDAR_FORMATS } from "modules/utils/Constants";

interface IProps {
  happycoWorkOrder?: HappycoWorkOrderFragment;
  search: string | string[];
}

const HappycoWorkOrderOptionLabel = ({ happycoWorkOrder, search }: IProps) => {
  const scheduleAndAssignee = useMemo(() => {
    if (!happycoWorkOrder) return "";
    const text: Array<string> = [];
    if (happycoWorkOrder.scheduleTime) {
      text.push(
        `Scheduled: ${moment(happycoWorkOrder.scheduleTime).calendar(
          COMMON_DATE_CALENDAR_FORMATS,
        )}`,
      );
    } else {
      text.push("Unscheduled");
    }
    if (happycoWorkOrder.assigneeName) {
      text.push(`Assigned To: ${happycoWorkOrder.assigneeName}`);
    } else {
      text.push("Unassigned");
    }
    return text.join(" • ");
  }, [happycoWorkOrder]);

  if (!happycoWorkOrder) return null;

  return (
    <VStack w="full" alignItems="flex-start" spacing={1}>
      <Text fontSize={14} fontWeight={600} color={colors.gray50}>
        <Highlight query={search}>{happycoWorkOrder.category ?? ""}</Highlight>
      </Text>
      <Text fontSize={12} fontWeight={600} color={colors.gray50}>
        <Highlight
          query={search}
        >{`${happycoWorkOrder.property} • ${happycoWorkOrder.location}`}</Highlight>
      </Text>
      <HStack w="full" spacing={0}>
        <Text fontSize={12} fontWeight={500} color={colors.grayMain}>
          <Highlight query={search}>{scheduleAndAssignee}</Highlight>
        </Text>
      </HStack>
    </VStack>
  );
};

export default memo(HappycoWorkOrderOptionLabel);
